//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createElement } from './stripe';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    placeholder: String,
  },
  data() {
    return {
      element: null,
      isFocused: false,
    };
  },
  mounted() {
    this.element = createElement(this.type, this.placeholder);
    this.element.mount(this.$el.querySelector('div'));
    this.$emit('mounted', this.element);
    this.element.on('focus', () => {
      this.isFocused = true;
    });
    this.element.on('blur', () => {
      this.isFocused = false;
    });
    this.element.on('change', (event) => {
      this.$emit('change', event);
    });
  },
  beforeDestroy() {
    this.element.destroy();
  },
};
